export const RICHFIELDS_KEYS = {
  MANDALA_CARD: 'MANDALA_CARD',
  DISCOVER_CARD: 'DISCOVER_CARD',
  COLLECTION: 'COLLECTION',
  SALON: 'SALON',
  INFOS_BLOC: 'INFOS_BLOC',
};

const slContainImage = {
  width: '100%',
  height: '100%',
  objectFit: 'contain',
};

const slCarrouCover = {
  width: '100%',
  height: 'auto',
  objectFit: 'cover',
  display: 'block',
};

const slCoverImage = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
};

const desktopBlocsMaxHeight = '400px';
const mobileBlocsMaxHeight = '200px';

const swiperDefaultConfig = {
  spaceBetween: 0,
  slidesPerView: 1,
  className: 'collection-swiper',
  loop: true,
  preloadImages: true,
  pagination: { clickable: true },
};

export const RICHFIELDS_CONFIG_MOBILE = {
  [RICHFIELDS_KEYS.COLLECTION]: {
    IMAGE_BANNER: {
      carouselView: true,
      carouselConfig: {
        ...swiperDefaultConfig,
        style: {
          maxHeight: mobileBlocsMaxHeight,
        },
      },
      img: {
        ...slCarrouCover,
      },
    },
  },
  [RICHFIELDS_KEYS.DISCOVER_CARD]: {
    IMAGE_BANNER: {
      img: {
        ...slCoverImage,
        maxHeight: mobileBlocsMaxHeight,
      },
    },
  },
  [RICHFIELDS_KEYS.SALON]: {
    IMAGE_BANNER: {
      carouselView: true,
      carouselConfig: {
        ...swiperDefaultConfig,
        style: {
          maxHeight: '215px',
        },
      },
      img: {
        ...slCarrouCover,
      },
    },
  },
};

export const RICHFIELDS_CONFIG_DESKTOP = {
  [RICHFIELDS_KEYS.SALON]: {
    IMAGE_BANNER: {
      carouselView: true,
      carouselConfig: {
        ...swiperDefaultConfig,
        style: {
          maxHeight: desktopBlocsMaxHeight,
        },
      },
      img: {
        ...slCarrouCover,
      },
    },
  },
  [RICHFIELDS_KEYS.COLLECTION]: {
    IMAGE_BANNER: {
      carouselView: true,
      carouselConfig: {
        ...swiperDefaultConfig,
        style: {
          maxHeight: desktopBlocsMaxHeight,
        },
      },
      img: {
        ...slCarrouCover,
      },
    },
  },
  [RICHFIELDS_KEYS.MANDALA_CARD]: {
    IMAGE_BANNER: {
      img: {
        ...slContainImage,
        objectPosition: 'top',
        maxHeight: desktopBlocsMaxHeight,
        height: 'auto',
        width: '100%',
      },
    },
  },
  [RICHFIELDS_KEYS.DISCOVER_CARD]: {
    IMAGE_BANNER: {
      img: {
        ...slCoverImage,
        maxHeight: desktopBlocsMaxHeight,
      },
    },
  },
  [RICHFIELDS_KEYS.INFOS_BLOC]: {
    NEWSFEED: {
      headerTitle: {
        display: 'none',
      },
      fullWrapper: {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        position: 'relative',
        gap: 'var(--gutter-m)',
      },
      newsTextWrapper: {
        position: 'absolute',
        bottom: '0',
        left: '0',
        zIndex: 2,
        width: '100%',
      },
      newsWrapper: {
        borderRadius: 'var(--b-radius)',
        border: '1px solid var(--secondary-color)',
        position: 'relative',
        width: '100%',
        marginBottom: '0px',
        height: 'auto',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
      },
      titleWrapper: {
        position: 'absolute',
        bottom: '100%',
        left: '50%',
        transform: 'translate(-50%, 50%)',
        zIndex: 2,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      imgWrapper: {
        overflow: 'hidden',
        marginBottom: '0px',
        height: 'auto',
        maxHeight: '350px',
      },
      img: {
        width: '100%',
        height: 'auto',
        objectFit: 'cover',
      },
      title: {
        backgroundColor: 'var(--secondary-color)',
        padding: 'var(--gutter-m)',
        color: 'var(--tertiary-color) !important',
        borderRadius: 'var(--b-radius)',
        fontFamily: "'Roboto Condensed', sans-serif",
        fontWeight: 'bold',
        fontStyle: 'italic',
        textTransform: 'uppercase',
        fontSize: 'clamp(1rem, 2.5vw, 1.4rem)',
        width: 'fit-content',
        margin: '0 auto',
      },
      buttonWrapper: {
        display: 'none',
      },
      desc: {
        color: 'var(--tertiary-color) !important',
      },
      paragraph: {
        fontSize: 'var(--fontsize-s)',
        overflow: 'hidden',
        height: 'auto',
        display: 'block',
        padding:
          'var(--gutter-xl) var(--gutter-m) var(--gutter-m) var(--gutter-m)',
        backgroundColor: 'var(--secondary-color)',
        color: 'var(--tertiary-color) !important',
        opacity: 0.8,
      },
    },
  },
};
